import { H3 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Title = styled(H3)`
  text-align: center;

  ${QUERIES.tabletAndUp} {
    font-size: ${themeStyle.fontSize26};
    line-height: 34px;
  }
`;
